import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error?.response) {
      if (
        error.response.status === 403 &&
        error.response.data === "jwt expired"
      ) {
        await localStorage.removeItem("token");
        window.location.href = "/";
        setTimeout(() => {
          toast.error("Token Expired, please login again");
        }, 1000);
      }
    }
    // toast.error(error?.response?.data?.message || error?.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
